import { render, staticRenderFns } from "./MiUnivisionarios.vue?vue&type=template&id=42a17a7c&"
import script from "./MiUnivisionarios.vue?vue&type=script&lang=js&"
export * from "./MiUnivisionarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports